export class GetSponserFilter { 
  SponserIdOrName !: string;
  Name !: string;
  SponserId!:string;
  IsActive!: string;
  GroupIds !: string;
}

export class ProductFilterDetails
{
 
  ProductName?: any;
  longName?:any;
  genericName?:any;
  internalName?:any;
  tradeName?:any;
  
}